export enum LOGOMAKER_CTA_VARIATIONS {
  Control = 'LogomakerCTAControl',
  Enabled = 'LogomakerCTAEnabled',
}

export const LOGOMAKER_CTA_EXPERIMENT_NAME = 'logomaker_in_business_card_flow_non-inferiority_test'
